export const XING_PROFILE = 'https://www.xing.com/profile/Stephan_Herzog11/';

export const GITHUB_PROFILE = 'https://github.com/sthzg';

export const UPWORK_PROFILE = 'https://www.upwork.com/freelancers/~019dfb0949dd83a1ad';

export const TWITTER_PROFILE = 'https://twitter.com/sthzg';

export const EMAIL_ADDRESS = 'sthzgvie@gmail.com';



// WEBPACK FOOTER //
// ../sthzgnet-base/lib/constants/index.js